import React, { useState } from "react";
import './SehirKameralariPage.scss';

const SehirKameralariPage = () => {
    const cameras = [
        { id: 'live-1', title: 'Ordu Büyükşehir Belediyesi', fileId: 'f8b52cd0-371b-46f1-a4ad-ecab84d5e0cc' },
        { id: 'live-2', title: 'Boztepe', fileId: '59d4b594-5ee3-491f-ba48-3a6576f4a836' },
        { id: 'live-3', title: 'Ünye Cumhuriyet Meydanı', fileId: 'ecfb3bc1-0a70-407c-be90-76b2467ff8a1' },
        { id: 'live-4', title: 'Çambaşı Kayak Merkezi', fileId: '01fe4c06-927e-4371-90ab-eaf50a7a43bd' },
        { id: 'live-5', title: 'Millet Bahçesi İnşaat Alanı', fileId: '93ba32bc-03cd-4a65-8c20-743fe9b446be' },
    ];

    // Başlangıçta ilk kamera aktif
    const [activeId, setActiveId] = useState(cameras[0].id);

    const activeCam = cameras.find(c => c.id === activeId) || cameras[0];

    return (
        <div className="sehir-kameralari page-root">
            <div className="container">
                <div className="sehir-kameralari-header">
                    <h1 className="page-title">Şehir Kameraları</h1>
                    <p className="page-desc">Aşağıda yer alan şehir kameraları, kentin farklı noktalarından canlı yayın yapmaktadır. Kameralar arasında gezinebilir ve anlık şehir görüntülerini izleyebilirsiniz.</p>
                </div>

                {/* Tabs */}
                <div className="kamera-tabs" role="tablist" aria-label="Kameralar">
                    {cameras.map(cam => (
                        <button
                            key={cam.id}
                            id={`tab-${cam.id}`}
                            role="tab"
                            aria-selected={activeId === cam.id}
                            aria-controls={`panel-${cam.id}`}
                            className={`kamera-tab ${activeId === cam.id ? 'active' : ''}`}
                            onClick={() => setActiveId(cam.id)}
                        >
                            <span className="kamera-icon" aria-hidden="true">
                                <svg viewBox="0 0 24 24" width="16" height="16" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true">
                                    <path d="M12 7a5 5 0 100 10 5 5 0 000-10zm7-2h-2.2l-1.3-1.6A1 1 0 0014.8 3H9.2a1 1 0 00-.7.4L7.2 6H5a2 2 0 00-2 2v8a2 2 0 002 2h14a2 2 0 002-2V7a2 2 0 00-2-2zM12 15.5A3.5 3.5 0 1112 8.5a3.5 3.5 0 010 7z"/>
                                </svg>
                            </span>
                            <span className="kamera-tab-label">{cam.title}</span>
                        </button>
                    ))}
                </div>

                {/* Active panel */}
                <div className="kamera-panel" role="tabpanel" id={`panel-${activeId}`} aria-labelledby={`tab-${activeId}`} tabIndex={0}>
                    <div className="kamera-meta">
                        <h2 className="kamera-title"><span className="kamera-icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true"><path d="M12 7a5 5 0 100 10 5 5 0 000-10zm7-2h-2.2l-1.3-1.6A1 1 0 0014.8 3H9.2a1 1 0 00-.7.4L7.2 6H5a2 2 0 00-2 2v8a2 2 0 002 2h14a2 2 0 002-2V7a2 2 0 00-2-2zM12 15.5A3.5 3.5 0 1112 8.5a3.5 3.5 0 010 7z"/></svg></span>{activeCam.title}</h2>
                    </div>

                    <div className="kamera-embed">
                        {/* Yalnızca aktif kamera için iframe render ediliyor */}
                        <iframe
                            title={activeCam.title}
                            src={`https://broadcast.orbel.com.tr/${activeCam.fileId}.html`}
                            className="kamera-iframe"
                            frameBorder="0"
                            allow="autoplay; encrypted-media; picture-in-picture"
                            allowFullScreen
                        />
                    </div>

                </div>

            </div>
        </div>
    );
}

export default SehirKameralariPage;